window.okeReviewsWidgetOnInit = function () {
    setupAggregate();

    const reviewMain = document.querySelector('.js-okeReviews-reviews-main');
    if (reviewMain) {
        const callback = function (mutationList) {
            for (const mutation of mutationList) {
                mutation.addedNodes.forEach(n => setupReviews(n));
            }
        };
        const observer = new MutationObserver(callback);
        observer.observe(reviewMain, {
            childList: true
        });
        // Run callback for the first time
        const reviews = document.querySelectorAll('.okeReviews-reviews-review');
        reviews.forEach(n => setupReviews(n));
    }
};

function setupAggregate() {
    const writeReviewButton = document.querySelector(".js-okeReviews-writeReview:not(.is-okeReviews-hidden)");
    const reviewsDropdown = document.querySelector(".okeReviews-reviews-controls .okeReviews-reviews-controls-select");

    if (reviewsDropdown) {
        if (writeReviewButton) {
            reviewsDropdown.insertAdjacentElement("beforebegin", writeReviewButton);
        }
        // Move reviews aggegrate and review button into control
        const reviewsAggregateMain = document.querySelector(".okeReviews-reviewsAggregate-primary");
        const reviewsControlHeader = document.querySelector(".okeReviews-reviews-controls .okeReviews-reviews-controls-sort");
        reviewsAggregateMain.insertAdjacentElement("beforeend", reviewsControlHeader);
    }
}

function setupReviews(nodeElement) {
    const productRecommendation = nodeElement.querySelector('.okeReviews-review-recommendation');
    const reviewMainControls = nodeElement.querySelector('.okeReviews-review-main-content-controls');
    if (productRecommendation && reviewMainControls) {
        // Move Product Recommendation Below Review Main Controls
        reviewMainControls.insertAdjacentElement('afterend', productRecommendation);
    }
}